import React, { useState } from "react";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import { EffectCoverflow, Pagination } from "swiper/modules";
import "../Swiper/Swiper.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa"; // Importing icons

const SwiperList = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedContent, setSelectedContent] = useState(null);

  const slides = [
    { src: "/vegas.jpg", title: "Vegas Holidays Packages", text: "Best Deal just 1 Call Away" },
    { src: "/india.jpg", title: "Magical India Packages", text: "Best Deal just 1 Call Away" },
    { src: "/maldives.jpg", title: "Maldives Holiday Packages", text: "Best Deal just 1 Call Away" },
    { src: "/dubai.jpg", title: "Dubai Holiday Packages", text: "Best Deal just 1 Call Away" },
    { src: "/orlando.png", title: "Orlando Holiday Packages", text: "Best Deal just 1 Call Away" },
    { src: "/thailand.jpg", title: "Thailand Holiday Packages", text: "Best Deal just 1 Call Away" }
];




  const openPopup = (image, title, text) => {
    setSelectedImage(image);
    setSelectedContent({ title, text });
  };

  const closePopup = () => {
    setSelectedImage(null);
    setSelectedContent(null);
  };

  // Navigation Component
  const NavigationButtons = () => {
    const swiper = useSwiper();
    return (
      <div className="swiper-nav-btns">
        <button onClick={() => swiper.slidePrev()}><FaArrowLeft /></button>
        <button onClick={() => swiper.slideNext()}><FaArrowRight /></button>
      </div>
    );
  };

  return (
    <>
      <div className="slider-as-s">
        <h2 className="offer-headingg mb-4">Exclusive Holiday Deals</h2>
        <Swiper
          effect={"coverflow"}
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={"auto"}
          initialSlide={2} // Default active 3rd image
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }}
          pagination={true}
          modules={[EffectCoverflow, Pagination]}
          className="mySwipera-s"
        >
          {slides.map((slide, index) => (
            <SwiperSlide
              key={index}
              className="swipersl-s"
              onClick={() => openPopup(slide.src, slide.title, slide.text)}
            >
            <div className="discount-box-s">Save up to 30%</div>
              <img src={slide.src} alt={`Slide ${index + 1}`} />
              <div className="overlay-s">
                <h2>{slide.title}</h2>
                <p>{slide.text}</p>
                <button className="btn-call-s">Call Now</button>
              </div>
            </SwiperSlide>
          ))}
          <NavigationButtons />
        </Swiper>
      </div>

      {/* Popup Section */}
      {selectedImage && (
        <div className="popup-overlay-s">
          <div className="popup-content-s">
            <span className="close-btn-s" onClick={closePopup}>&times;</span>
            <div className="popup-image-container-s">
              <img src={selectedImage} alt="Selected Slide" />
              <div className="popup-overlay-content-s">
                <h2>{selectedContent?.title}</h2>
                <p>{selectedContent?.text}</p>
                <button className="btn-call-s">Call Now</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SwiperList;